import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TFillBonusesValue = IAction<EPaymentActions.FILL_BONUSES_VALUE, number>

const fillBonusesValue = (bonusesValue: number): TFillBonusesValue => ({
    type: EPaymentActions.FILL_BONUSES_VALUE,
    payload: bonusesValue,
});

export default fillBonusesValue;
